import { InstrumentTags } from '@gasbuddy/payment-serv-client/InstrumentTags';
import getBankAccount from './getBankAccount';

export default function getMDReadyAccount(instruments = []) {
  return getBankAccount(instruments.filter(i => i.tags?.includes(InstrumentTags.MicrodepositMade)));
}
